import {
  client,
  localizationApiListLabels,
} from '@blk/aladdin-graph-client-axios-internal/wealth/shared_service/localization/v1/localization_api';
import { API_TIMEOUT } from '../../APIConstants';
import { aGraph, getAGraphBaseUrl, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_LOCALIZATION_API_AGRAPH_URL } from './Constants';

interface Settings extends AGraphApiSettings {
  getPkgFn?: () => string | undefined;
}

export const awLocalizationSettings: Settings = {};

export const awLocalizationClient = client;
export const awLocalizationApi = client.instance;

awLocalizationApi.interceptors.request.use((config) => {
  const { getAladdinApiKey, getEnvTypeFn } = awLocalizationSettings;
  config.baseURL = getAGraphBaseUrl(AW_LOCALIZATION_API_AGRAPH_URL);
  config.timeout = API_TIMEOUT;
  setAGraphHeaders(config, getAladdinApiKey?.(), getEnvTypeFn?.());
  return config;
});

export async function getLocalizedLabels(
  locale: string,
  pkg: string,
  pageToken?: string
): Promise<{ [language: string]: { [key: string]: string } }> {
  const overrideConfigDirectory = awLocalizationSettings.getConfigurationDirectoryFn?.();
  const resp = await aGraph(localizationApiListLabels, {
    query: {
      locale,
      pkg,
      ...(overrideConfigDirectory && { overrideConfigDirectory }),
      ...(pageToken && { pageToken }),
    },
  });

  const { localizations, nextPageToken } = resp.data;

  // Start with localizations from current page
  let allLocalizations = localizations;

  // If there's a next page, recursively fetch and combine
  if (nextPageToken) {
    const nextPageData = await getLocalizedLabels(locale, pkg, nextPageToken);
    // Get the translations from the next page and convert back to array format
    const nextPageLocalizations = Object.entries(nextPageData[locale] || {}).map(([id, translation]) => ({
      id,
      translation,
    }));
    // Combine with current page
    allLocalizations = [...allLocalizations, ...nextPageLocalizations];
  }

  // Convert array of localization objects to the expected nested structure
  const transformedData = {
    [locale]: allLocalizations.reduce(
      (acc: { [key: string]: string }, localization: { id: string; translation: string }) => {
        acc[localization.id] = localization.translation;
        return acc;
      },
      {}
    ),
  };

  return transformedData;
}
